export default "__VITE_ASSET__DkHtPmFh__"